/**
 * Course Quiz API endpoints (authenticated)
 */

import { fetchApi } from '../core';
import type { CourseQuizInfo, StartQuizResponse, CourseQuizAnswerData, QuizSubmissionResponse } from '../types';

export function getQuizInfo(courseId: string, assignmentId: string, componentName: string = 'Unknown'): Promise<CourseQuizInfo> {
  return fetchApi(`/courses/${courseId}/assignments/${assignmentId}/quiz-info`, {}, componentName);
}

export function startQuiz(courseId: string, assignmentId: string, componentName: string = 'Unknown'): Promise<StartQuizResponse> {
  return fetchApi(`/courses/${courseId}/assignments/${assignmentId}/start`, {
    method: 'POST'
  }, componentName);
}

export function saveAnswer(submissionId: string, data: CourseQuizAnswerData, componentName: string = 'Unknown') {
  return fetchApi(`/submissions/${submissionId}/quiz-answer`, {
    method: 'POST',
    body: JSON.stringify(data)
  }, componentName);
}

export function submitQuiz(submissionId: string, componentName: string = 'Unknown'): Promise<QuizSubmissionResponse> {
  return fetchApi(`/submissions/${submissionId}/quiz-submit`, {
    method: 'POST'
  }, componentName);
}

export function getResults(submissionId: string, componentName: string = 'Unknown'): Promise<QuizSubmissionResponse> {
  return fetchApi(`/submissions/${submissionId}/quiz-results`, {}, componentName);
}
